import api from "./api";
import cache from "../utils/cache";

export const getBasicData = async () => {
  try {
    const response = await api.get("/users/basicdata");
    return response.data;
  } catch (error) {
    console.error("Error fetching basic data:", error);
    throw error;
  }
};

export const getMentors = async () => {
  try {
    const response = await api.get("/users/mentor");
    return response.data;
  } catch (error) {
    console.error("Error fetching mentors:", error);
    throw error;
  }
};

export const getLocationByPincode = async (pincode) => {
  try {
    const response = await api.get(`/location/get-location-by-pincode/${pincode}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching location:", error);
    throw error;
  }
};

export const updateUserProfile = async (profileData) => {
    try {
        const response = await api.patch("/users/profile", profileData);
        return response.data;
    } catch (error) {
        console.error("Update User Profile Error:", error);
        throw error;
    }
};

/* export const getBanners = async (payload) => {
    try {
        const response = await api.get("/banner", {params: payload});
        return response.data;
    } catch (error) {
        console.error("Error fetching banners:", error);
        throw error;
    }
}; */

export const getBanners = async (payload) => {
  try {
    const cacheKey = `banners-${JSON.stringify(payload)}`;
    const cachedData = await cache.get(cacheKey);

    if (cachedData) {
      /* console.log("Banners: Cache"); */

      api.get("/banner", { params: payload })
        .then(async (response) => {
          const freshData = response.data;

          await cache.set(cacheKey, freshData, "30m");

          /* console.log("Banners cache updated"); */
        })
        .catch((error) => {
          console.error("Background banner API error:", error);
        });

      return cachedData;
    }

    /* console.log("Banners: API"); */

    const response = await api.get("/banner", {
      params: payload,
    });

    const data = response.data;

    await cache.set(cacheKey, data, "30m");

    return data;
  } catch (error) {
    console.error("Error fetching banners:", error);
    throw error;
  }
};

export const getVisitorCount = async () => {
    try {
        const response = await api.post("/visitor-count");
        return response.data;
    } catch (error) {
        console.error("Error fetching visitor count:", error);
        throw error;
    }
};


export const getRecitationPoems = async (payload) => {
  try {
    const response = await api.get("/event/recitation-poems", {
      params: payload
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching recitation poems:", error);
    throw error;
  }
};